import { QueryFunction, useQuery } from 'react-query';
import {
    getAllMachines,
    GetMachinesQueries,
    getMachineWithLastLocation,
    GetMonthlyMachineParams,
    getMonthlyMachines,
    Machine,
    MachineWithLastLocation,
    MonthlyMachine
} from '../../services/apiSLTP/materials/machines';

type UseMachinesQueryOptions = {
    queries?: GetMachinesQueries;
};

const getMachines: QueryFunction<Machine[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseMachinesQueryOptions];
    const { queries } = options;

    const response = await getAllMachines(queries);
    return response.data;
};

export const useMachinesQuery = (options: UseMachinesQueryOptions) => {
    return useQuery(['machines', options], getMachines);
};

type UseMachinesWithLastLocationQueryOptions = {
    date: Date;
};

const getMachinesLastLocations: QueryFunction<MachineWithLastLocation[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseMachinesWithLastLocationQueryOptions];
    const { date } = options;

    const response = await getMachineWithLastLocation(date);
    return response.data;
};

export const useMachinesWithLastLocationsQuery = (options: UseMachinesWithLastLocationQueryOptions) => {
    return useQuery(['machines locations', options], getMachinesLastLocations);
};

type UseMonthlyMachinesQueryOptions = {
    params: GetMonthlyMachineParams;
};

const getMonthlyMachinesQuery: QueryFunction<MonthlyMachine[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseMonthlyMachinesQueryOptions];
    const { params } = options;

    const response = await getMonthlyMachines(params);
    return response.data;
};

export const useMonthlyMachinesQuery = (options: UseMonthlyMachinesQueryOptions) => {
    return useQuery(['monthly machines', options], getMonthlyMachinesQuery);
};
